import { Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { FileCheck02 } from '@untitled-ui/icons-react';
import { LooseObject } from 'api/types';
import { StatusTag } from 'components/StatusTag';
import { useTranslation } from 'react-i18next';

export const B2CVerificationStatusCard = (props: {
  currentStatus: string;
  workshopVerificationQueryData: LooseObject;
  isTaskAssigned: boolean;
}) => {
  const { t } = useTranslation();
  const { currentStatus, workshopVerificationQueryData: workshopVerificationQuery, isTaskAssigned } = props;

  const statusDescriptionKey = isTaskAssigned && currentStatus === 'submitted' ? 'processing' : currentStatus;

  return (
    <HStack justifyContent="space-between" width={'100%'} alignItems={'flex-start'}>
      <HStack alignItems="flex-start">
        <FileCheck02 />

        <HStack>
          <Heading as="h2" size="xxs">
            {`${t('b2c_verification:verification.header')} ( ${workshopVerificationQuery?.user_readable_id} )`}
          </Heading>
        </HStack>
      </HStack>

      <VStack alignItems="flex-end">
        <StatusTag resourceKey="b2c_verification_request" currentStatus={currentStatus} isCell />

        <Text fontSize={'sm'} fontWeight={'bold'} as={'span'} textColor={'grey'}>
          {t(`b2c_verification:status.description.${statusDescriptionKey}`)}
        </Text>
      </VStack>
    </HStack>
  );
};
